import AvatarModal from "../AvatarModal";

const RenderPages = () => {
  return <AvatarModal />;
};

export default RenderPages;
